import { render, staticRenderFns } from "./CoursesModal.vue?vue&type=template&id=5adff775&scoped=true&"
import script from "./CoursesModal.vue?vue&type=script&lang=ts&"
export * from "./CoursesModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesModal.vue?vue&type=style&index=0&id=5adff775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adff775",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5adff775', component.options)
    } else {
      api.reload('5adff775', component.options)
    }
    module.hot.accept("./CoursesModal.vue?vue&type=template&id=5adff775&scoped=true&", function () {
      api.rerender('5adff775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/CoursesModal.vue"
export default component.exports